import React from 'react'
import { Button } from 'react-bootstrap'
import { HowToVideo } from '../../../../services/cellcast.type'
import { getCategoryDisplayName } from '../../../Utils/videoUtils'

interface AdminVideoCardProps {
  video: HowToVideo
  onEdit: (video: HowToVideo) => void
  onDelete: (id: string) => void
  onToggleStatus: (id: string, currentStatus: boolean) => void
  isDeleting?: boolean
}

const AdminVideoCard: React.FC<AdminVideoCardProps> = ({
  video,
  onEdit,
  onDelete,
  onToggleStatus,
  isDeleting = false
}) => {
  return (
    <div className='card h-100'>
      <div className='card-body d-flex flex-column'>
        {/* Video Thumbnail */}
        <div className='text-center mb-4'>
          <img
            src={video.imagePath || 'https://cel-public-assets.s3.ap-southeast-2.amazonaws.com/cel_coming_soon.png'}
            alt={video.title}
            className='img-fluid rounded'
            style={{ maxHeight: '150px', objectFit: 'cover' }}
          />
        </div>

        {/* Video Info */}
        <div className='flex-grow-1'>
          <h5 className='card-title text-dark fw-bold mb-2'>{video.title}</h5>
          <p className='card-text text-muted mb-3' style={{ fontSize: '0.9rem' }}>
            {video.description}
          </p>

          {/* Category and Status */}
          <div className='d-flex justify-content-between align-items-center mb-3'>
            <span className='badge badge-light-primary'>
              {getCategoryDisplayName(video.category)}
            </span>
            <span className={`badge badge-light-${video.isActive ? 'success' : 'danger'}`}>
              {video.isActive ? 'Active' : 'Inactive'}
            </span>
          </div>

          {/* Video URL indicator */}
          {video.videoUrl && (
            <div className='mb-3'>
              <small className='text-success'>
                <i className='bi bi-check-circle me-1'></i>
                Video URL configured
              </small>
            </div>
          )}
        </div>

        {/* Action Buttons - Matches table view styling */}
        <div className='d-flex justify-content-end gap-2 mt-3 pt-3 border-top'>
          <Button
            variant='light'
            size='sm'
            title='Edit'
            onClick={() => onEdit(video)}
          >
            Edit
          </Button>
          <Button
            variant='light-danger'
            size='sm'
            title='Delete'
            onClick={() => onDelete(video._id)}
            disabled={isDeleting}
          >
            {isDeleting ? 'Deleting...' : 'Delete'}
          </Button>

        </div>
      </div>
    </div>
  )
}

export default AdminVideoCard